import type { LocationEntry } from '@latency-globe/shared';
import { el } from './dom.ts';

/** SPEC §9.7 — no WebGL2: still truthful, not interactive. */
export function renderFallback(reason: string, locations: LocationEntry[] | null): void {
  const table = el('table', {}, el('thead', {}, el('tr', {}, el('th', { text: 'Code' }), el('th', { text: 'Location' }), el('th', { text: 'Status' }))));
  const body = el('tbody');
  for (const l of locations ?? []) body.append(el('tr', {}, el('td', { text: l.code }), el('td', { text: l.name ?? '' }), el('td', { text: l.status })));
  table.append(body);
  document.body.append(el('div', { class: 'fallback' }, el('div', { class: 'inner' },
    el('h1', { text: 'nearest cloud' }),
    el('p', { text: 'A crowdsourced map of which cloud location actually serves each place on earth: cells coloured by the location that most consenting visitors from that cell reached.' }),
    el('p', { text: reason }),
    el('p', { text: 'The map data is available as JSON at /api/map/cloudflare?precision=2, and these are the Cloudflare locations seen so far:' }),
    table,
  )));
}
